// eslint-disable-next-line import/no-extraneous-dependencies
import * as transliteration from 'transliteration';

// eslint-disable-next-line import/prefer-default-export
export const convertUnicodeToAscii = (inputText) => transliteration.transliterate(inputText);

export const convertDataToUrl = async (blobOrFile) => {
  const reader = new FileReader();
  reader.readAsDataURL(blobOrFile);

  await new Promise(
    // eslint-disable-next-line no-return-assign
    (resolve) =>
      // eslint-disable-next-line no-promise-executor-return
      (reader.onload = () => {
        resolve();
      })
  );

  return reader.result;
};
